import { SERVICE_LIST } from "@mercdev.com/mercurial-ui/navigation";
import { useUser } from "@mercdev.com/mercury-id-authorization";
import { useMemo } from "react";

export const useServices = () => {
  const { user } = useUser();

  return useMemo(() => {
    const permissions = user?.permissions;
    if (!permissions) return [];

    return SERVICE_LIST.filter((s) => {
      if (s.icon === "shortener") return false;
      const perms = (permissions as Record<string, unknown>)[s.icon];
      return Array.isArray(perms) && perms.length > 0;
    }).map((item) => ({
      name: item.name,
      link: item.link,
      icon: item.icon,
      onClick: () => window.open(item.link, "_blank"),
    }));
  }, [user?.permissions]);
};
